import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { UserData, userDataState } from 'components/account/account.state';

import { debugState } from './DebugManager.state';

declare global {
  interface Window {
    __SCALYR_SET_DEBUG__: (value: boolean) => void;
    __SCALYR_USER_DATA__?: UserData;
    __SCALYR_LABS_ENABLED__?: string[];
  }
}

export const DebugManager = () => {
  const [isDebug, setDebug] = useRecoilState(debugState);
  const userData = useRecoilValue(userDataState);

  useEffect(() => {
    window.__SCALYR_SET_DEBUG__ = (value: boolean = true) => setDebug(value);
  }, [setDebug]);

  useEffect(() => {
    if (isDebug) {
      window.__SCALYR_USER_DATA__ = userData;
      window.__SCALYR_LABS_ENABLED__ = (userData?.labs ?? [])
        .filter(({ enabled }) => enabled)
        .map(({ name }) => name)
        .sort();
    } else {
      delete window.__SCALYR_USER_DATA__;
      delete window.__SCALYR_LABS_ENABLED__;
    }
  }, [isDebug, userData]);

  return <></>;
};
